import { alpha, GlobalStyles, useTheme } from '@rossum/ui/material';

export const SchemaEditorStyles = () => {
  const theme = useTheme();

  return (
    <GlobalStyles
      styles={{
        '.schema-id-annotation': {
          color: alpha(theme.palette.text.secondary, 0.6),
          fontSize: '11px',
          fontFamily: 'monospace',
          fontStyle: 'italic',
          lineHeight: '16px',
          pointerEvents: 'none',
        },
        '.codeMarker': {
          position: 'absolute',
          background: alpha(theme.palette.warning.main, 0.3),
        },
      }}
    />
  );
};
